import { useEffect, useState } from 'react'
import { type EnrollmentDetails } from 'core/types'
import { ServiceProviderMap } from 'Pages/CaregiverPortal/InterestForm/Step4/ServiceProviderMap'
import { ServiceProviderSearch } from 'Pages/CaregiverPortal/InterestForm/Step4/ServiceProviderSearch'
import { ServiceSummary } from 'Pages/CaregiverPortal/InterestForm/Step4/ServiceSummary'
import { sendGet } from 'hooks/use-fetch'
import { useParams } from 'react-router-dom'

export interface ServiceProviderStepProps {
  handleStep: (backwards: boolean) => void
  caregiverForm: EnrollmentDetails
}

export function ServiceProviderStep (props: ServiceProviderStepProps): JSX.Element {
  const { isdId } = useParams()
  const [maxProviders, setMaxProviders] = useState<number | undefined>(undefined)
  const caregiverForm = props.caregiverForm

  useEffect(() => {
    const fetchData = async (): Promise<void> => {
      const { response, success } = await sendGet(`/CaregiverPortal/GetISDMaxProviders/${isdId ?? ''}`, {})
      if (success) {
        setMaxProviders(response ?? undefined)
      }
    }

    void fetchData()
  }, [])

  if (caregiverForm.currentSubStep === 1) {
    return <ServiceProviderSearch caregiverForm={caregiverForm} handleStep={props.handleStep} maxProviders={maxProviders} />
  } else if (caregiverForm.currentSubStep === 2) {
    return <ServiceProviderMap caregiverForm={caregiverForm} handleStep={props.handleStep} maxProviders={maxProviders} />
  } else if (caregiverForm.currentSubStep === 3) {
    return <ServiceSummary caregiverForm={caregiverForm} handleStep={props.handleStep} />
  }

  return <></>
}
